// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3mVv9","errorLogs":"EditorFooter_errorLogs__3gi2W"};